"use client"

import { Spinner } from "@/components/ui/spinner"

type FullscreenLoadingScreenProps = {
  label?: string
}

export function FullscreenLoadingScreen({ label = "Loading…" }: FullscreenLoadingScreenProps) {
  return (
    <div className="flex h-screen items-center justify-center bg-[#f8f4ec]">
      <div className="flex flex-col items-center gap-3 rounded-[1.5rem] border border-[rgba(116,102,70,0.14)] bg-[linear-gradient(180deg,rgba(255,251,244,0.96)_0%,rgba(247,239,224,0.92)_100%)] px-8 py-7 shadow-[0_24px_70px_rgba(91,78,43,0.1)] ring-1 ring-white/45">
        <Spinner className="size-5 border-t-[#7c452f]" />
        <p className="text-sm font-medium text-[#6c6254]">{label}</p>
      </div>
    </div>
  )
}
